import * as React from 'react';
import './SupportSearchingNSearchResults.css';

export default class SupportSearchingNSearchResults extends React.Component<any, any> {
  render() {
    return (
      <div className="searching-box">
        <h2>Searching & Search Results</h2>
        <h3>Tips on Historical Searching</h3>
        <p>
          Land records and titling is complex in nature. The NSW Land Registry Services search guides provide information on researching land records. Click here to view and download <a href="https://nswlrs.com.au/services/record-searches/historical-research" target="_blank">NSW LRS search guides</a>
        </p>
        <p>
          Further information about collections in the HLRV and online can be viewed at <a href="https://nswlrs.com.au/services/record-searches/historical-research" target="_blank">Historical Records Online</a> in the NSW LRS website.
        </p>
        <h3>Searching by Attribute</h3>
        <img src="screenshots/attribute-search.png" alt="Searching by Attribute" />
        <p>
          An attribute is a searching value, or a metadata field, associated to each of the record sets. For example, an attribute for Parish Map is 'Parish name', for Old Form Torrens Register the attribute is 'Vol-Fol'. It relates to the metadata captured for a record set.
        </p>
        <p>
          Select an 'Attribute' to search on from the left dropdown panel. Then type the value to be searched on into the text box on the right. The value is not case-sensitive but only images that have exactly the entered value for the selected attribute will be retrieved. It is recommended a keyword search is performed where the correct value is unknown.
        </p>
        <p>
          All image collections will be searched unless the image collection selection is changed in the left of the screen (see the <a href="#filtering_by_image_collections"><b>Filtering by Image Collections (Search For)</b></a> section below).
        </p>
        <h3>Searching by Keyword</h3>
        <img src="screenshots/keyword-search.png" alt="Searching by Keyword" />
        <p>
          When searching by ‘Keyword’ type a keyword into the textbox and press <img src="screenshots/search-icon.png" alt="Search Icon"/> to execute the search.
        </p>
        <p>
          The metadata (which is data captured about the records) held against images will be searched for the keyword. This includes geographic area names such as counties, parishes and towns as well as reference numbers such as Volume Folio Numbers for Old Form Torrens Register titles.
        </p>
        <p>
          <b>TIP:</b> Narrow the search results by filtering searches by record collection. All image collections will be searched unless the selection is changed in the left of the screen (see the <a href="#filtering_by_image_collections"><b>Filtering by Image Collections (Search For)</b></a> section).
        </p>
        <p>
          The keyword is not case-sensitive. A partial keyword can be entered e.g. searching on "ba" will retrieve index and map results matching from the beginning of the value i.e. Bathurst maps, Conditional Purchase Index surname initial "BA", etc.
        </p>
        <h3>Searching by Lot (Reference Map Search)</h3>
        <img src="screenshots/lot-search.png" alt="Searching by Lot" />
        <p>
          To search for an LTO charting map by 'Lot' type the Lot Number, Section Number (if appropriate) and Plan Number into the appropriate panels. Plan Type will default to DP (Deposited Plan) alternatively SP (Strata Plan) can be selected from the dropdown option.
        </p>
        <p>
          Press <img src="screenshots/search-btn.png" alt="Search Button"/> to execute the search. The reference maps in the LTO charting map collection for the lot searched will be returned.
        </p>
        <h3 id="filtering_by_image_collections">Filtering by Image Collections (Search For) </h3>
        <p>
          Often it is advisable to filter the search to retrieve only the image collection that is desired. This can be done using the collections and attribute lists in the left of the HLRV screen. By default all of the images are included in the search.
        </p>
        <p>
          Collections can be removed by clicking the <img src="screenshots/checkbox-checked.png" alt="Checkbox"/> and reinstated by clicking the <img src="screenshots/checkbox-unchecked.png" alt="Checkbox Unchecked"/>. Multiple collections can be included and/or removed by clicking their parent collection. The <img src="screenshots/right-arrow.png" alt="Right Arrow"/> and <img src="screenshots/down-arrow.png" alt="Down Arrow"/> buttons can be used to open and close a parent collection to reveal or hide child collections.
        </p>
        <h3>Search Results</h3>
        <p>
          Upon executing a search, the search results pane is opened and the results are listed in tiles. The heading of the pane shows the number of results in the current page and total matches:
        </p>
        <p>
          <img src="screenshots/search-results.png" alt="Search Results"/>
        </p>
        <p>
          A maximum of 15 results will be displayed per page of results.
        </p>
        <p>
          Where there are more than 15 results found, the current page is highlighted and other pages can be clicked on to navigate to them directly.
        </p>
        <p>
          Alternatively, click <img src="screenshots/results-skip-5-pages.png" alt="Skip 5 pages" style={{ verticalAlign: 'middle' }}/> to skip to the next 5 pages of results or enter the desired results page number into the text box to the right of ‘Go to page’.
        </p>
        <p style={{ fontStyle: 'italic' }}>
          <strong>Warning</strong> Jumping through large volumes of result pages, e.g. page 519, will lead to display of a warning prompt advising to refine the search by collections in the search tree.
        </p>
        <p>
          <img src="screenshots/results-pagination.png" alt="Results Pagination"/>
        </p>
        <p>
          Pressing <img src="screenshots/result-icon-with-count.png" alt="Result Icon"/> will load a result returned into the image viewer
        </p>
        <br/>
        <h3>Other Buttons</h3>
        <p>
          Pressing <img src="screenshots/help-icon.png" alt="Help Icon" style={{ verticalAlign:'middle' }}/> will display this help page.
        </p>
        <p>
          Pressing <img src="screenshots/lrs-logo.png" alt="NSW LRS Logo" style={{ verticalAlign:'middle' }}/> will return to the landing page
        </p>
        <h3>Notes on Collections and Attributes</h3>
        <p>
          To avoid confusion, it should be noted that collections only have a few attributes associated with them based on the data available. For example, Parish Maps utilise the Parish Name and County Name attributes but Town Maps do not - and instead utilise the Town Name attribute.
        </p>
        <p>
          All images have an Image Name attribute. This is usually some combination of other attributes e.g. County of Pottinger Parish of Baan Baa.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SupportSearchingNSearchResults.tsx